module.exports = __webpack_public_path__ + "img/427445753.0ff17d30.jpg";